import { ReflectionType as MyType } from '@shapeable/villars-types';
import { EntityConfig, entityStandardFormFields } from '@shapeable/core';
export const ReflectionType: EntityConfig<MyType> = {
  name: 'ReflectionType',
  label: 'Reflection Type',
  type: 'taxonomy',
  includeInSearch: true,
  list: {
    resultsVariant: 'list',
  },
  autoRoutes: ['create', 'update', 'list'],
  form: {
    fields: {
      ...entityStandardFormFields,
      description: { type: 'longText' },
    }
  },
}; 